export default function IconCaretDown(props) {
  return (
    <svg width="7" height="7" viewBox="0 0 10 10" fill="currentColor" {...props}>
      <path d="M2 3l3 4 3-4z"/>
    </svg>
  )
}
